<template>
  <div class="fwb">
    <el-button type="text" @click="fwbBtn" v-if="textShow">{{
      btnTitle
    }}</el-button>
    <el-input
      v-if="textShow && !fwb"
      type="textarea"
      :rows="3"
      :placeholder="text"
      show-word-limit
      :maxlength="300"
      v-model="value"
      onkeydown="if (event.keyCode===13){return false;}"
    >
    </el-input>
    <editor
      v-if="(show && !textShow) || fwb"
      v-model="value"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
      :placeholder="placeholders"
    >
    </editor>
    <!-- <div class="ed-loading" v-show="show">
    	<a-spin size="large" />
    </div> -->
  </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";
import axios from "axios";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/fullscreen";
import "tinymce/icons/default";
import "tinymce/plugins/paste";

import { getFileAccessHttpUrl,fileUpdates} from "@/api/index";
// import { getVmParentByName } from '@/utils/util'
export default {
  components: {
    Editor,
  },
  props: {
    text: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    textShow: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default:
        "lists  link  textcolor wordcount contextmenu fullscreen image",
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists link unlink | removeformat | image fullscreen",
      branding: false,
    },
  },
  data() {
    return {
      baseURL,
      btnTitle: "开启富文本",
      fwb: false,
      // show:false,
      //初始化配置
      init: {
        language_url: "/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "/tinymce/skins/lightgray",
        //  content_css: 'tinymce/skins/content/default/content.css', //以css文件方式自定义可编辑区域的css样式，css文件需自己创建并引入
        content_css: "/tinymce/skins/content/document/content.css",
        branding: false,
        height: this.height,
        plugins: this.plugins,
        height: 300,
        file_picker_types: "file image media",
        menubar: "file edit insert view format table",
        menu: {
          view: { title: "View", items: "preview | fullscreen" },
        },
        ax_wordlimit_num: 50000,
        ax_wordlimit_callback: function (editor, txt, num) {
          editor.execCommand("undo");
        },
        // default_link_target: "_blank", //链接默认打开模式
        toolbar: this.toolbar,
        //word文档黏贴的插件及其配置
        powerpaste_word_import: "propmt", // 参数可以是propmt, merge, clear，效果自行切换对比
        powerpaste_html_import: "propmt", // propmt, merge, clear
        powerpaste_allow_local_images: true,
        convert_urls: false,
        relative_urls: false,
        paste_data_images: true,
        toolbar_drawer: false,
        urlconverter_callback: function (url, node, on_save, name) {
          if (node === "img" && url.startsWith("blob:")) {
            tinymce.activeEditor && tinymce.activeEditor.uploadImages();
          }
          return url;
        },
        // external_plugins: {
        //   powerpaste:
        //     "/tinymce/plugins/powerpaste/plugin.min.js", //word文档黏贴的插件
        // },
        images_upload_handler: (blobInfo, success, callback) => {
          let formData = new FormData();
          // let file = this.files[0];
          formData.append("file", blobInfo.blob(), blobInfo.filename());
          formData.append("biz", "jeditor");
          formData.append("jeditor", "1");
          fileUpdates("/sys/common/upload", formData)
            .then((response) => {
              console.log(response);
              if (response.code == 0) {
                success(
                  `${baseURL}/sys/common/static/${response.message}`
                );
              } else {
                callback("图片格式错误");
              }
            })
            .then((error) => {
              console.log(error);
            });
        },
        media_live_embeds: false,
        file_picker_callback: function (callback, value, meta) {
          const that = this;
          if (meta.filetype === "media" || meta.filetype === "file") {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", ".pdf,.mp4");
            //input.setAttribute('accept',  '.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .mp4')
            input.click();
            input.onchange = function () {
              let file = this.files[0];
              let formData = new FormData();
              formData.append("file", file);
              formData.append("isType", "FWB");
              formData.append("biz", "linxuan");
              formData.append("linxuan", "1");
              fileUpdates("/sys/common/upload", formData)
                .then((response) => {
                  //  console.log(response);
                  let cfile =baseURL+response.message;
                  //  console.log(cfile);
                  callback(cfile,{text:response.message});
                })
                .catch((error) => {
                  console.log(error);
                });
              // axios
              //   .post(baseURL + "/sys/common/local/upload", formData)
              //   .then((response) => {
              //     callback(
              //       `${baseURL}/sys/common/stat
              //       ic/${response.data.result.path}`,
              //       { text: response.data.result.title }
              //     );
              //   })
              //   .then((error) => {
              //     console.log(error);
              //   });
            };
          }
          if (meta.filetype == "image") {
            var filetype = ".jpg,.png,.jpeg,.gif";
            var formData = new FormData();
            var input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", filetype);
            input.click();
            input.onchange = async function () {
              var file = this.files[0];
              let formData = new FormData();
              formData.append("file", file);
              formData.append("biz", "jeditor");
              formData.append("jeditor", "1");
              fileUpdates("/sys/common/upload", formData)
                .then((response) => {
                  //  let cfile = getFileAccessHttpUrl(response.message);
                  // //  console.log(cfile);
                  // callback(cfile,{text:response.message});
                  callback(
                    `${baseURL}/sys/common/static/${response.message}`
                  );
                })
                .catch((error) => {
                  callback(error);
                  console.log(error);
                });
            };
          }
        },

        //        video_template_callback: data => {
        //        	console.log(data);
        //          return `<video width="auto" height="auto" controls="controls" src=${data.source} />`
        //        }
      },
      value: "",
      placeholders: this.placeholder,
      reloading: false,
    };
  },
  mounted() {
    tinymce.init({});
    // this.initATabsChangeAutoReload()
  },
  methods: {
    uploadAction(url, parameter) {
      return axios({
        url: url,
        data: parameter,
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data", // 文件上传
        },
      });
    },
    reload() {
      this.reloading = true;
      this.$nextTick(() => (this.reloading = false));
    },

    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    //可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    },
    fwbBtn() {
      this.btnTitle = this.fwb ? "开启富文本" : "关闭富文本";
      this.fwb = !this.fwb;
    },
    /**
     * 自动判断父级是否是 <a-tabs/> 组件，然后添加事件监听，自动触发reload()
     *
     * 由于 tabs 组件切换会导致 tinymce 无法输入，
     * 只有重新加载才能使用（无论是vue版的还是jQuery版tinymce都有这个通病）
     */
    initATabsChangeAutoReload() {
      // 获取父级
      let tabs = getVmParentByName(this, "ATabs");
      let tabPane = getVmParentByName(this, "ATabPane");
      if (tabs && tabPane) {
        // 用户自定义的 key
        let currentKey = tabPane.$vnode.key;
        // 添加事件监听
        tabs.$on("change", (key) => {
          // 切换到自己时执行reload
          if (currentKey === key) {
            this.reload();
          }
        });
        //update--begin--autor:liusq-----date:20210316------for：富文本编辑器tab父组件可能导致的赋值问题------
        this.reload();
        //update--end--autor:liusq-----date:20210316------for：富文本编辑器tab父组件可能导致的赋值问题------
      } else {
        //update--begin--autor:wangshuai-----date:20200724------for：富文本编辑器切换tab无法修改------
        let tabLayout = getVmParentByName(this, "TabLayout");
        //update--begin--autor:liusq-----date:20210713------for：处理特殊情况excuteCallback不能使用------
        try {
          tabLayout.excuteCallback(() => {
            this.reload();
          });
        } catch (error) {
          if (tabLayout) {
            this.reload();
          }
        }
        //update--end--autor:liusq-----date:20210713------for：处理特殊情况excuteCallback不能使用------
        //update--begin--autor:wangshuai-----date:20200724------for：文本编辑器切换tab无法修改------
      }
    },
  },
  watch: {
    text(newValue) {
      // if (newValue && newValue.indexOf("&nbsp;") != -1) {
      //   let reg1 = new RegExp('&nbsp;', "g");
      //   this.value = newValue.replace(reg1,"");
      // }else{
      this.value = newValue;
      // }
    },
    placeholder(newValue) {
      this.placeholders = newValue;
    },
    value(newValue) {
      this.fwb = /^<p>/.test(newValue);
      if (this.fwb) {
        this.btnTitle = "关闭富文本";
      } else {
        this.btnTitle = "开启富文本";
      }
      this.$emit("input", newValue);
    },
  },
};
</script>
<style scoped lang="scss">
.ed-loading {
  width: 100%;
  height: 300px;
  position: absolute;
  top: 0px;
  left: 0px;
  text-align: center;
  line-height: 300px;
}
.fwb {
  position: relative;
  .el-button {
    position: absolute;
    z-index: 999999;
    right: 10px;
    top: 0;
  }
}
</style>
